import React from 'react';
import { useTranslation } from 'react-i18next';
import AppointmentRow from '../AppointmentRow/AppointmentRow';
import './UpcomingAppointmentsCard.css';

/**
 * UpcomingAppointmentsCard — full-width card listing the next upcoming appointments.
 *
 * @component
 * @param {object}    props
 * @param {string}    props.title     - Card heading text.
 * @param {object[]}  props.events    - Array of calendar event objects to display.
 * @param {boolean}   [props.loading] - When `true` shows shimmer skeleton rows.
 * @param {function}  props.onEdit    - Called with the event when the user clicks "Edit".
 * @param {function}  props.onDelete  - Called with the event when the user clicks "Delete".
 */
const UpcomingAppointmentsCard = ({
    title,
    events = [],
    loading = false,
    onEdit,
    onDelete,
}) => {
    const { t } = useTranslation();

    return (
        <div className="uac-card">
            {/* Header */}
            <div className="uac-header">
                <h3 className="uac-title">{title}</h3>
            </div>

            <hr className="uac-divider" />

            {/* Body */}
            <div className="uac-body">
                {loading ? (
                    Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="uac-skeleton-row" />
                    ))
                ) : events.length === 0 ? (
                    <p className="uac-empty">{t('no-upcoming-appointments')}</p>
                ) : (
                    events.map(ev => (
                        <AppointmentRow
                            key={ev._id}
                            event={ev}
                            onEdit={onEdit}
                            onDelete={onDelete}
                        />
                    ))
                )}
            </div>
        </div>
    );
};

export default UpcomingAppointmentsCard;
